import { render, staticRenderFns } from "./WsDotStatus.vue?vue&type=template&id=18b112cc"
import script from "./WsDotStatus.vue?vue&type=script&lang=js"
export * from "./WsDotStatus.vue?vue&type=script&lang=js"
import style0 from "./WsDotStatus.vue?vue&type=style&index=0&id=18b112cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports